<template>
  <div class="filter-item">
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <md-field>
          <label for="status">Тип кассы</label>
          <md-select v-model="value" name="cashType" id="cashType" @md-selected="changeCashFilter" md-dense>
            <md-option v-for="v in items"
                       :value="v.value"
                       :key="v.value">{{ v.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cashType',
  data () {
    return {
      items: [
        {name: 'Все', value: 'deleteFilter'},
        {name: 'Azur POS', value: 1},
        {name: 'Light касса', value: 2},
        {name: 'EasyShop касса (без фискализации)', value: 3}
      ],
      value: null
    }
  },
  methods: {
    changeCashFilter () {
      this.$store.commit('setCashFilter', {name: 'status_id', value: this.value})
      this.$emit('changeCashFilter')
    }
  },
  created () {
    if (this.$store.state.filtersCash['status_id'] !== null) {
      this.value = this.$store.state.filtersCash.status_id
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/filters/cashbox/type.vue